import { type EmptyObject, moneyFormatNoDecimal, P, Stack, useText } from "@sveabank/cc-common";
import type { SelectedPackage } from "../../types/package";
import { isSelectedProductCreditProduct, type ProductDefinitionId } from "../../types/product";
import type { SelectedAddonsRecord } from "./product-section";

type Props = {
	selectedPackage: SelectedPackage;
	selectedAddons: EmptyObject | SelectedAddonsRecord;
	product: ProductDefinitionId;
};

const ProductItemContent = ({ selectedPackage, selectedAddons, product }: Props) => {
	const [t, texts] = useText();
	return (
		<Stack direction="col" gap={1}>
			<div className="pl-6">
				{selectedPackage.products
					.filter(isSelectedProductCreditProduct)
					.filter(
						(p) =>
							p.isAddon &&
							p.productDefinitionId === selectedAddons[product].product.productDefinitionId,
					)
					.map((item, index) => (
						<P key={item.productId}>
							{selectedAddons[product].product.productDefinitionId === "CREDITCARD"
								? t(texts.summaryPage.creditCard, (index + 1).toString())
								: ""}
							{t(
								texts.summaryPage.creditLimit,
								moneyFormatNoDecimal(+item.chosenCredit.amount, true).toString(),
							)}
						</P>
					))}
			</div>
		</Stack>
	);
};

export default ProductItemContent;
